export default __webpack_public_path__ + "static/media/icon-chat.9e0f61c3.svg";